<template>
  <v-navigation-drawer v-model="visible" absolute temporary id="filters" app height="100%" width="450px" fixed>
    <v-row>
      <div class="close">
        <v-icon medium color="#18305A" @click.stop="visible = false">mdi-close</v-icon>
      </div>
      <v-col style="padding: 20px">
        <h5>
          Type of transaction
        </h5>
        <v-radio-group v-model="filters.transactionType" @change="changed">
          <v-radio
            v-for="option in options.transactionType"
            :key="option.name"
            :label="option.name"
            :value="option.value"
            color="#18305A"
            ></v-radio>
        </v-radio-group>
        <br />
        <h5>Sectors of interest</h5>
        <p class="caption">Check all that apply</p>
        <v-checkbox
          label="All industries"
          class="main-checkbox"
          color="#18305A"
          v-model="filters.industrySectors"
          value="all"
          @change="changed"
        ></v-checkbox>
        <div id="sectorFrame">
          <div class="child">
            <v-checkbox
              v-for="item in options.industrySectors"
              v-model="filters.industrySectors"
              :key="item.value"
              :label="item.name"
              :value="item.name"
              color="#18305A"
              hide-details
              @change="changed"
            ></v-checkbox>
          </div>
        </div>

        <br />
        <h5>Regional Focus</h5>
        <br />
        <v-checkbox
          label="All Africa"
          class="main-checkbox"
          color="#18305A"
          hide-details
          v-model="filters.regionalFocus"
          @change="changed"
          value="all"
        ></v-checkbox>
        <v-checkbox
          v-for="item in options.regionalFocus"
          v-model="filters.regionalFocus"
          hide-details
          :key="item.value"
          :label="item.name"
          :value="item.value"
          color="#18305A"
          @change="changed"
        ></v-checkbox>

        <br />
        <h5>Deal size</h5>
        <br />
        <v-checkbox
          label="All ranges"
          class="main-checkbox"
          hide-details
          color="#18305A"
          v-model="filters.dealRanges"
          value="all"
          @change="changed"
        ></v-checkbox>
        <v-checkbox
          v-for="item in options.dealRanges"
          v-model="filters.dealRanges"
          hide-details
          :key="item.key"
          :label="item.name"
          :value="item.value"
          color="#18305A"
          @change="changed"
        ></v-checkbox>
        <br />
        <h5>Deal structure</h5>
        <v-radio-group v-model="filters.dealStructure" @change="changed">
          <v-radio
            v-for="option in [{ name: 'Any' }].concat(options.dealStructure)"
            :key="option.name"
            :label="option.name"
            :value="option.name"
            color="#18305A"
            ></v-radio>
        </v-radio-group>
        <br />
        <br />
        <br />
        <br />
        <br />
        <div class="actions">
          <v-btn x-medium color="#f0b323" @click="save">
            Save As Default
          </v-btn>
          <v-btn x-medium @click="reset">
            Clear All
          </v-btn>
        </div>
      </v-col>
    </v-row>

  </v-navigation-drawer>
</template>

<script type="application/javascript">
import options from '@/data/options'
import _ from 'lodash'

export default {
  name: 'filters',
  props: {
    show: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      options,
      previous: {},
      shadow: {}
    }
  },
  computed: {
    visible: {
      get () {
        return this.show
      },
      set (value) {
        if (!value) this.$emit('close')
      }
    },
    interest () {
      return this.$store.getters['deals/interest'] || {}
    },
    filters () {
      const dflt = {
        industrySectors: [],
        dealRanges: [],
        regionalFocus: [],
        transactionType: [],
        dealStructure: null
      }
      if (_.isEmpty(this.shadow) && _.isEmpty(this.interest)) return dflt

      return _.defaults(this.shadow, this.$store.getters['deals/filters'], dflt)
    }
  },
  methods: {
    changed () {
      Object.keys(this.filters).forEach((type) => {
        if (type === 'dealStructure' || type === 'transactionType') return

        const added = (this.filters[type] || []).filter(i => !(this.previous[type] || []).includes(i))
        const removed = (this.previous[type] || []).filter(i => !(this.filters[type] || []).includes(i))

        if (added.includes('all')) {
          this.filters[type] = this.options[type].map(i => i.value || i.name || i.label).concat('all')
        }

        if (removed && removed.length) {
          this.filters[type] = this.filters[type].filter(i => i !== 'all')
        }
      })

      this.previous = _.cloneDeep(this.filters)
      this.$store.dispatch('deals/filters', _.cloneDeep(this.filters))
    },
    save () {
      const interest = Object.assign(this.interest, {
        ..._.pick(this.filters, ['industrySectors', 'dealRanges', 'regionalFocus', 'dealStructure'])
      })

      if (!interest.dealStructure) delete interest.dealStructure
      interest.other = Object.assign(interest.other || {}, { transactionType: this.filters.transactionType })
      this.$store.dispatch('deals/update', { interest })
      this.visible = false
    },
    reset () {
      this.shadow = null
      this.$store.dispatch('deals/filters', {
        industrySectors: [],
        dealRanges: [],
        regionalFocus: [],
        transactionType: [],
        dealStructure: null
      })
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";
#filters {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100601;
  background: white;
  padding: 40px;
  height: 100%;
  overflow: hidden;
  h5 {
    color: $text-primary;
    font-family: $header-font;
    font-size: 12px;
    font-weight: 600;
    line-height: 130%;
    text-transform: uppercase;
  }
  .caption {
    color: #93979D;
  }
  .v-input--checkbox {
    margin-top: 0px;
    color:#18305A;
  }
  .v-input {
    line-height: 115%;
    font-size: 18px;
    color:#18305A;
  }
  .v-navigation-drawer__content {
    overflow-y: scroll;
    box-sizing: content-box;
    position: absolute;
    top: 0px;
    padding-top: 40px;
    right: -17px;
    padding-right: 40px;
    left: 0px;
    padding-left: 40px;
  }
  .actions {
    background-color: #FFF9E6;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    padding: 20px;
    button {
      padding: 5px 15px;
      margin: 0 10px;
    }
  }
}
.deals-list {
  .v-overlay {
    position: fixed;
    top: 0;
    left: 0;
  }
}
#sectorFrame {
  overflow-y: scroll;
  border: 1px solid rgba(147, 151, 157, 0.26);
  box-sizing: border-box;
  border-radius: 4px;
  height: 400px;
}
.close {
  position: fixed;
  top: 30px;
  right: 30px;
  font-size: 48px;
  font-style: normal;
  font-weight: 200;
  font-size: 48px;
  line-height: 150%;
  display: flex;
  align-items: center;
}
.main-checkbox {
  & ::v-deep label {
    font-weight: bold;
  }
}
</style>
